import {IGeneralColors} from "../../architecture/sections/general-colors.interface";
import {baseColors} from "./base-colors";

export const shellGeneralColors: IGeneralColors  = {
    brandPrimary: baseColors.base02,
    brandPrimaryDark: baseColors.base01,
    brandPrimaryLight: baseColors.base01,
    brandPrimaryContrast: baseColors.base01Contrast,

    brandSecondary: baseColors.base01,
    brandSecondaryDark: baseColors.base01Dark,
    brandSecondaryLight: baseColors.base01Light,
    brandSecondaryContrast: baseColors.base01Contrast,

    backgroundDark: baseColors.base01Dark,
    backgroundMiddleDark: baseColors.base01Dark,
    background: baseColors.base01, //bodyBackground
    backgroundLight: baseColors.base03, //bodyBackgroundLight
    backgroundHover: baseColors.base01Dark,
    backgroundActive: baseColors.base02,
    backgroundContrast: baseColors.white,
    iconBackgroundActive: baseColors.transparent,
    logoBackground: baseColors.base01,

    textDark: baseColors.base01Dark,
    textMiddleDark: baseColors.white,
    text: baseColors.gray213,
    textLight: baseColors.base03, //bodyText
    textHover: baseColors.white,
    textActive: baseColors.base01Light,
    textContrast: baseColors.white,
    moneyColor: baseColors.base03,

    boxBorderDark: baseColors.base01Dark,
    boxBorderMediumDark: baseColors.gray023,
    boxBorder: baseColors.base01Dark,
    boxBorderLight: baseColors.base01,
    boxBorderLighter: baseColors.base03,
    boxBorderContrast: baseColors.white, //bodyInfo
    modalDialogBorder: baseColors.gray053,

    danger: baseColors.white,
    dangerDark: baseColors.base05,
    dangerLight: baseColors.base05,

    buttonDark: baseColors.base01,
    buttonLight: baseColors.base02,
    buttonInfo: baseColors.gray113,
    buttonWarning: baseColors.base01,

    horizontalLineBackgroundColor: baseColors.base01Dark,
    horizontalLineBackgroundImage: "",

    gameModeRealBackground: baseColors.gray023,
    gameModeDemoBackground: baseColors.white,

    sportBrandPrimary: "",
    pokerBrandPrimary: "",
};